import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem,
  Avatar, useTheme, useMediaQuery
} from '@mui/material';
import { 
  AccountCircle, 
  Settings, 
  Logout,
  Menu as MenuIcon,
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onMenuToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuToggle }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleProfile = () => { setAnchorEl(null); navigate('/profile'); };
  const handleLogout = () => { logout(); setAnchorEl(null); navigate('/login'); };

  return (
    <AppBar
      position="fixed"
      elevation={1}
      sx={{
        zIndex: (t) => t.zIndex.drawer + 1,
        background: 'white',
        color: 'text.primary',
        borderBottom: '1px solid #e2e8f0',
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
      }}
    >
      <Toolbar sx={{ minHeight: 70, px: { xs: 2, md: 3 }, gap: 1 }}>
        {/* Sol grup: Mobil hamburger + Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Mobil menü butonu */}
          <IconButton 
            color="inherit" 
            onClick={onMenuToggle} 
            sx={{ 
              display: { md: 'none' },
              color: '#64748b'
            }}
            aria-label="Menüyü aç/kapat"
          >
            <MenuIcon />
          </IconButton>

          {/* Logo ve Başlık */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {/* Şirket Logosu - Buraya gerçek logo resmini ekleyin */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              {/* Logo */}
              <Box
                component="img"
                src="/aksanteknolojilogo.png"
                alt="Aksan Teknoloji"
                sx={{
                  width: 195,          // ihtiyaca göre 100–160 arası oynat
                  height: 60,
                  objectFit: 'contain',
                }}
              />

            </Box>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

{/* Sağ grup: kullanıcı menüsü */}
<Box
  onClick={(e) => setAnchorEl(e.currentTarget)}
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    px: 2,
    py: 1,
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '1px solid #e2e8f0',
    background: 'white',
    '&:hover': {
      backgroundColor: '#f8fafc',
      borderColor: '#cbd5e1'
    }
  }}
>
  {/* Tarih - İnce ve zarif tasarım */}
  <Box sx={{ 
    textAlign: 'center',
    pr: 2,
    borderRight: '1px solid #f1f5f9'
  }}>
    <Typography variant="caption" sx={{ 
      fontWeight: 300, 
      color: '#475569',
      fontSize: '0.75rem',
      display: 'block',
      fontFamily: "'Inter', sans-serif",
      letterSpacing: '0.5px'
    }}>
      {new Date().toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
    </Typography>
    <Typography variant="caption" sx={{ 
      color: '#94a3b8',
      fontWeight: 400,
      fontSize: '0.7rem',
      fontFamily: "'Inter', sans-serif",
      letterSpacing: '0.3px',
      fontStyle: 'italic'
    }}>
      {new Date().toLocaleDateString('tr-TR', { weekday: 'long' })}
    </Typography>
  </Box>

  <Box sx={{ textAlign: 'right' }}>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b', fontSize: '0.85rem' }}>
      {user?.name}
    </Typography>
    <Typography variant="caption" sx={{ 
      color: '#64748b', 
      fontWeight: 400,
      fontSize: '0.7rem'
    }}>
      {user?.role === 'admin' ? 'Yönetici' : user?.role === 'support' ? 'Destek' : 'Müşteri'}
    </Typography>
  </Box>
  
  <Avatar 
    sx={{ 
      width: 36, 
      height: 36, 
      bgcolor: '#3b82f6',
      fontSize: '14px', 
      fontWeight: 600,
      border: '2px solid white',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
    }}
  >
    {user?.name?.charAt(0).toUpperCase()}
  </Avatar>
</Box>

        <Menu
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              mt: 1.5, 
              minWidth: 180, 
              borderRadius: '12px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
              border: '1px solid #e2e8f0',
              '& .MuiMenuItem-root': { 
                fontSize: '0.9rem', 
                py: 1.25,
                '&:hover': {
                  backgroundColor: '#f8fafc'
                }
              }
            },
          }}
        >
          <MenuItem onClick={handleProfile}>
            <AccountCircle sx={{ mr: 2, fontSize: 20, color: '#64748b' }} />
            Profilim
          </MenuItem>
          <MenuItem onClick={() => { setAnchorEl(null); navigate('/settings'); }}>
            <Settings sx={{ mr: 2, fontSize: 20, color: '#64748b' }} />
            Ayarlar
          </MenuItem>
          <MenuItem onClick={handleLogout} sx={{ color: '#ef4444' }}>
            <Logout sx={{ mr: 2, fontSize: 20, color: '#ef4444' }} />
            Çıkış Yap
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;